<span class="rounded-full bg-[#DFF2F9] px-2 py-1 text-sm">
  {{ message() }}
</span>
